export const CATALOG_PAGE_PATH = '/catalogue/';
export const SERVICES_PAGE_PATH = '/uslugi/';
export const APRO_PAGE_PATH = '/biznes/';
export const ROOMS_PAGE_PATH = '/rooms/';

export const B2B_PERSONAL_ACCOUNT_HOST = '/lkb2b/';
